
const messages = {
  en: {
    marca: {
      title: 'Marca management',
      menuTitle: 'Brands',
      subtitle: 'View, search, create, edit and delete Marca',
      creating: 'Creating Marca',
      editing: 'Editing Marca',
      deleting: 'Deleting Marca',
      showing: 'Showing Marca',
      labels: {
        nombre: 'name'
      },
      modals: {
        updateImpact: {
          title: 'Confirm update',
          description: 'Updating this brand will affect {productosCount} products in {depositosCount} deposits.',
          confirmQuestion: 'Do you want to continue?',
        },
        deleteImpact: {
          title: 'Confirm delete',
          description: 'Deleting this brand will unlink {productosCount} products in {depositosCount} deposits.',
          confirmQuestion: 'Do you want to continue?',
        },
      },
    },
  },
  es: {
    marca: {
      title: 'Administración de Marca',
      menuTitle: 'Marcas',
      subtitle: 'Ver, buscar, crear, editar, y borrar Marca',
      creating: 'Creando Marca',
      editing: 'Modificando Marca',
      deleting: 'Eliminando Marca',
      showing: 'Detalles de Marca',
      labels: {
        nombre: 'nombre'
      },
      modals: {
        updateImpact: {
          title: 'Confirmar actualización',
          description: 'Actualizar esta marca afectará {productosCount} productos en {depositosCount} depósitos.',
          confirmQuestion: '¿Desea continuar?',
        },
        deleteImpact: {
          title: 'Confirmar eliminación',
          description: 'Eliminar esta marca desvinculará {productosCount} productos en {depositosCount} depósitos.',
          confirmQuestion: '¿Desea continuar?',
        },
      },
    },
  },
  pt: {
    marca: {
      title: 'Administração de Marca',
      menuTitle: 'Marcas',
      subtitle: 'Ver, buscar, criar, editar e usar Marca',
      creating: 'Criando Marca',
      editing: 'Edição Marca',
      deleting: 'Apagando Marca',
      showing: 'Detalhes do Marca',
      labels: {
        nombre: 'nome'
      },
      modals: {
        updateImpact: {
          title: 'Confirmar atualização',
          description: 'Atualizar esta marca afetará {productosCount} produtos em {depositosCount} depósitos.',
          confirmQuestion: 'Deseja continuar?',
        },
        deleteImpact: {
          title: 'Confirmar exclusão',
          description: 'Excluir esta marca desvinculará {productosCount} produtos em {depositosCount} depósitos.',
          confirmQuestion: 'Deseja continuar?',
        },
      },
    },
  },
}

export default messages
